import { css } from '@linaria/core';
import { styled } from '@linaria/react';

import { Captions, SubHeadline } from '~components/Typography';

import { heightList } from '../constants';
import type { Size } from '../types';

export const Icon = styled(SubHeadline)`
	&:not(.disabledIconStyles) {
		display: flex;
		height: var(--button-icon-size);
		padding: var(--button-icon-padding);
		& > * {
			width: auto;
			height: 100%;
		}
	}
`;

const content = `
	display: flex;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;`;

export const MainContent = styled(SubHeadline)`
	${content}
`;
export const MainContentCaptions = styled(Captions)`
	${content}
`;

const generateStyle = (size: Size) => `
	height: ${heightList[size]};
`;

export const styledButton = css`
	&.sizeBadge {
		${generateStyle('Badge')}
	}

	&.sizeS {
		${generateStyle('S')}
	}

	&.sizeM {
		${generateStyle('M')}
	}

	&.sizeL {
		${generateStyle('L')}
	}
`;
